import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { MAIN_PHONE_FEATURE, MainPhoneMenu, MainPhoneState } from '../main-phone-state';

export const getFeatureState: MemoizedSelector<MainPhoneMenu, MainPhoneState> =
  createFeatureSelector<MainPhoneState>(MAIN_PHONE_FEATURE);
